import { getSdk } from '../../generated/graphql';
import { GraphQLClient } from 'graphql-request';

export const endpoint = `${process.env.REACT_APP_CONTENTFUL_ENDPOINT}/${
  process.env.REACT_APP_CONTENTFUL_SPACE_ID
}/environments/${process.env.REACT_APP_CONTENTFUL_ENVIRONMENT || 'master'}`

export const graphQlClient = new GraphQLClient(endpoint, {
  headers: {
    Authorization: `Bearer ${process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN}`,
  },
});

const previewGraphQlClient = new GraphQLClient(endpoint, {
  headers: {
    Authorization: `Bearer ${process.env.REACT_APP_CONTENTFUL_PREVIEW_ACCESS_TOKEN}`,
  },
});

export const client = getSdk(graphQlClient) as ReturnType<typeof getSdk>;
export const previewClient = getSdk(previewGraphQlClient) as ReturnType<typeof getSdk>;

